import "./ClientRegistrationEmergencyContactDetailsComponent.scss";
import * as Yup from "yup";
import {IClientEmergencyContactDetails,} from "../../../shared/models/client.model";
import {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {Field, FieldArray, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../constants";
import FormDebuggerComponent from "../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikInputComponent from "../../../shared/components/form-controls/formik-input/FormikInputComponent";
import FormikSelectDropdownComponent
    from "../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import IconButtonComponent from "../../../shared/components/icon-button/IconButtonComponent";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";
import HorizontalLineComponent
    from "../../../shared/components/horizontal-line/horizontal-line/HorizontalLineComponent";
import {getClientBasicDetails} from "../../../store/actions/client.action";
import FormikPhoneInputComponent from "../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import {setFormChangesData} from "../../../store/actions/form-state.action";

interface ClientRegistrationEmergencyContactDetailsComponentProps {
    onNext: () => void;
    appointmentId: any
}

const contactInfoSchema = Yup.object({
    phone_type: Yup.string().required('Phone type is required'),
    phone: Yup.string().required('Phone number is required'),
});

const ClientEmergencyContactDetailsFormValidationSchema = Yup.object({
    emergency_contact_info: Yup.object({
        primary_emergency: Yup.object({
            name: Yup.string().required('Full Name is required')
                .max(100, 'Full Name cannot be more than 100 characters'),
            relationship: Yup.string().required('Relationship is required'),
            language: Yup.string().required('Language is required'),
            primary_contact_info: Yup.object({
                phone_type: Yup.string().required('Phone Type is required'),
                phone: Yup.string().required('Phone Number is required'),
            })
        }),
        // secondary_emergency: Yup.object({
        //     name: Yup.string().required('Full Name is required')
        //         .max(100, 'Full Name cannot be more than 100 characters'),
        // })
    }),
});

const ClientEmergencyContactDetailsFormInitialValues: IClientEmergencyContactDetails = {
    show_secondary_emergency_form: false,
    emergency_contact_info: {
        primary_emergency: {
            name: "",
            relationship: "",
            language: "",
            primary_contact_info: {
                phone_type: "",
                phone: ""
            },
        },
        secondary_emergency: {
            name: "",
            relationship: "",
            language: "",
            primary_contact_info: {
                phone_type: "",
                phone: ""
            },
        }
    },
}


const ClientRegistrationEmergencyContactDetailsComponent = (props: ClientRegistrationEmergencyContactDetailsComponentProps) => {

    const {onNext} = props;
    const dispatch = useDispatch();
    const [clientEmergencyContactDetailsFormInitialValues, setClientEmergencyContactDetailsFormInitialValues] = useState<IClientEmergencyContactDetails>(_.cloneDeep(ClientEmergencyContactDetailsFormInitialValues));

    const {
        clientBasicDetails,
        isClientBasicDetailsLoaded,
    } = useSelector((state: IRootReducerState) => state.client);

    const {
        phoneTypeList,
        relationshipList,
        languageList
    } = useSelector((state: IRootReducerState) => state.staticData);

    useEffect(() => {
            console.log(clientBasicDetails);
            if (isClientBasicDetailsLoaded) {
                const primaryEmergency = clientBasicDetails?.emergency_contact_info?.primary_emergency;
                if ((primaryEmergency?.secondary_contact_info?.every((contact: any) => contact.phone_type === "" && contact.phone === ""))) {
                    clientBasicDetails.emergency_contact_info.primary_emergency.secondary_contact_info = null;
                }
                const tempSecondaryEmergency = clientBasicDetails?.emergency_contact_info?.secondary_emergency;
                if ((tempSecondaryEmergency?.secondary_contact_info?.every((contact: any) => contact.phone_type === "" && contact.phone === ""))) {
                    clientBasicDetails.emergency_contact_info.secondary_emergency.secondary_contact_info = null;
                }
                if (tempSecondaryEmergency?.name || tempSecondaryEmergency?.language_details || tempSecondaryEmergency?.relationship || tempSecondaryEmergency?.primary_contact_info?.phone || tempSecondaryEmergency?.primary_contact_info?.phone_type || (tempSecondaryEmergency?.secondary_contact_info?.length > 0
                    && tempSecondaryEmergency?.secondary_contact_info.some((contact: any) => contact.phone_type !== "" || contact.phone !== ""))) {
                    clientBasicDetails.show_secondary_emergency_form = true;
                } else {
                    clientBasicDetails.show_secondary_emergency_form = false;
                }
                setClientEmergencyContactDetailsFormInitialValues(clientBasicDetails);
            }
        }
        ,
        [clientBasicDetails, isClientBasicDetailsLoaded]
    )
    ;

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {...values, is_emergency_details_updated: true};
        payload.is_emergency_details_filled = true;
        // payload.emergency_contact_info.primary_contact_info.phone = payload?.emergency_contact_info?.primary_contact_info?.phone?.replace(/\D/g, '');
        CommonService._client.ClientBasicDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                dispatch(getClientBasicDetails());
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, [dispatch, onNext]);

    return (
        <div
            className={'client-registration-details-block client-registration-emergency-contact-details-component'}>
            <div className="client-registration-details-block__header">
                <div className="client-registration-details-block__title">
                    Emergency Contact Details
                </div>
            </div>
            <div className="client-registration-details-block__body">
                <Formik
                    validationSchema={ClientEmergencyContactDetailsFormValidationSchema}
                    initialValues={clientEmergencyContactDetailsFormInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={onSubmit}
                >
                    {({values, setFieldValue, validateForm, isValid, isSubmitting, dirty}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                            if (dirty) {
                                dispatch(setFormChangesData(true));
                            }
                        }, [validateForm, values, dirty]);
                        return (
                            <Form className="t-form" noValidate={true}>
                                <FormDebuggerComponent values={values} showDebugger={false}/>
                                <div className="t-form-controls with-icons">
                                    <div className={'form-header'}>Primary Emergency Contact</div>
                                    <div className="ts-row">
                                        <div className={'ts-col'}>
                                            <Field name={'emergency_contact_info.primary_emergency.name'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            id={'full_name_input'}
                                                            label={'Full Name'}
                                                            placeholder={'Enter Full Name'}
                                                            type={"text"}
                                                            required={true}
                                                            titleCase={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col">
                                            <Field
                                                name={'emergency_contact_info.primary_emergency.relationship'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            id={'relationship_dd'}
                                                            options={relationshipList}
                                                            label={'Relationship'}
                                                            placeholder={'Select Relationship'}
                                                            required={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            isClearable={false}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className={"ts-col-1"}></div>
                                    </div>
                                    <div className="ts-row">
                                        <div className="ts-col">
                                            <Field name={'emergency_contact_info.primary_emergency.language'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            id={'language_dd'}
                                                            options={languageList}
                                                            label={'Language'}
                                                            placeholder={'Select Language'}
                                                            required={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            isClearable={false}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col">
                                        </div>
                                        <div className="ts-col-md-1">
                                        </div>
                                    </div>
                                    <div className={'form-header'}>Primary Phone</div>
                                    <div className="ts-row">
                                        <div className="ts-col">
                                            <Field
                                                name={'emergency_contact_info.primary_emergency.primary_contact_info.phone_type'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            id={"p_phone_type"}
                                                            options={phoneTypeList}
                                                            label={'Phone Type'}
                                                            required={true}
                                                            placeholder={'Select Phone Type'}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            isClearable={false}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col">
                                            <Field
                                                name={'emergency_contact_info.primary_emergency.primary_contact_info.phone'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikPhoneInputComponent
                                                            id={"p_phone_number"}
                                                            label={'Phone Number'}
                                                            disabled={!values?.emergency_contact_info?.primary_emergency?.primary_contact_info?.phone_type}
                                                            placeholder={'Enter Phone Number'}
                                                            required={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col-md-1 registration-form-icons-wrapper">
                                            <IconButtonComponent className={"form-helper-icon"}>
                                                <ToolTipComponent
                                                    isFormTooltip={true}
                                                    showArrow={true}
                                                    position={"left"}
                                                    tooltip={<div className={'justified-text'}>This phone number will be
                                                        used to communicate with your emergency contact in case of an
                                                        emergency. Please ensure that this number is valid and
                                                        operational.</div>}>
                                                    <ImageConfig.InfoIcon/>
                                                </ToolTipComponent>
                                            </IconButtonComponent>
                                        </div>
                                    </div>
                                    <FieldArray
                                        name="emergency_contact_info.primary_emergency.secondary_contact_info"
                                        render={(arrayHelpers) => {
                                            const secondaryContactInfo = values?.emergency_contact_info?.primary_emergency?.secondary_contact_info ?? [];

                                            return (
                                                <>
                                                    {secondaryContactInfo.length > 0 ? (
                                                        <>
                                                            <div className={'form-header'}>Alternate Phone</div>
                                                            {secondaryContactInfo.map((item: any, index: any) => (
                                                                <div key={index}>

                                                                    <div className="ts-row">
                                                                        <div className="ts-col">
                                                                            <Field
                                                                                name={`emergency_contact_info.primary_emergency.secondary_contact_info[${index}].phone_type`}>
                                                                                {(field: FieldProps) => (
                                                                                    <FormikSelectDropdownComponent
                                                                                        options={phoneTypeList}
                                                                                        label={'Phone Type'}
                                                                                        placeholder={'Select Phone Type'}
                                                                                        formikField={field}
                                                                                        fullWidth={true}
                                                                                        isClearable={false}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                        <div className="ts-col">
                                                                            <Field
                                                                                name={`emergency_contact_info.primary_emergency.secondary_contact_info[${index}].phone`}>
                                                                                {(field: FieldProps) => (
                                                                                    <FormikPhoneInputComponent
                                                                                        label={'Phone Number'}
                                                                                        disabled={secondaryContactInfo && !secondaryContactInfo[index]?.phone_type}
                                                                                        placeholder={'Enter Phone Number'}
                                                                                        formikField={field}
                                                                                        fullWidth={true}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                        <div
                                                                            className="ts-col-md-1 registration-form-icons-wrapper">
                                                                            <IconButtonComponent
                                                                                className={"form-helper-icon"}
                                                                                onClick={() => {
                                                                                    arrayHelpers.remove(index);
                                                                                }}
                                                                            >
                                                                                <ImageConfig.DeleteIcon
                                                                                    color={"#E84142"}/>
                                                                            </IconButtonComponent>
                                                                            {secondaryContactInfo.length < 3 && (
                                                                                <IconButtonComponent
                                                                                    className={"form-helper-icon"}
                                                                                    disabled={!contactInfoSchema.isValidSync(secondaryContactInfo[index])}
                                                                                    onClick={() => {
                                                                                        arrayHelpers.push({
                                                                                            phone_type: "",
                                                                                            phone: ""
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    <ImageConfig.AddCircleIcon/>
                                                                                </IconButtonComponent>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <ButtonComponent
                                                            variant={"link"}
                                                            color={"info"}
                                                            size={"small"}
                                                            prefixIcon={<ImageConfig.AddCircleFilled/>}
                                                            onClick={() => {
                                                                setFieldValue('emergency_contact_info.primary_emergency.secondary_contact_info', [{
                                                                    phone_type: "",
                                                                    phone: ""
                                                                }]);
                                                            }}
                                                        >
                                                            Add Alternate Phone
                                                        </ButtonComponent>
                                                    )}
                                                </>
                                            );
                                        }}
                                    />


                                    <HorizontalLineComponent marginBottom={true}/>
                                    {
                                        !values.show_secondary_emergency_form && <div>
                                            <ButtonComponent variant={"link"}
                                                             color={"info"}
                                                             prefixIcon={<ImageConfig.AddCircleFilled/>}
                                                             onClick={() => {
                                                                 setFieldValue('show_secondary_emergency_form', true);
                                                             }}
                                            >
                                                Add Secondary Contact
                                            </ButtonComponent>
                                        </div>
                                    }

                                    <>
                                        {
                                            values?.show_secondary_emergency_form && <>
                                                <div
                                                    className="d-flex flex-1 justify-content-space-between align-items-center mrg-bottom-20 mrg-top-25">
                                                    <div className="form-header-without-margin">Secondary Emergency
                                                        Contact
                                                    </div>
                                                    <ButtonComponent variant={"outlined"}
                                                                     color={"error"}
                                                                     size={"small"}
                                                                     prefixIcon={<ImageConfig.DeleteIcon/>}
                                                                     onClick={() => {
                                                                         setFieldValue('show_secondary_emergency_form', false);
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.name', "");
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.relationship', "");
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.language', "");
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.primary_contact_info.phone_type', "");
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.primary_contact_info.phone', "");
                                                                         setFieldValue('emergency_contact_info.secondary_emergency.secondary_contact_info', [{
                                                                             phone_type: "",
                                                                             phone: ""
                                                                         }]);
                                                                     }}
                                                    >
                                                        Delete
                                                    </ButtonComponent>
                                                </div>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field
                                                            name={'emergency_contact_info.secondary_emergency.name'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        label={'Full Name'}
                                                                        placeholder={'Enter Full Name'}
                                                                        type={"text"}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col">
                                                        <Field
                                                            name={'emergency_contact_info.secondary_emergency.relationship'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        options={relationshipList}
                                                                        label={'Relationship'}
                                                                        placeholder={'Select Relationship'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                        isClearable={false}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className={"ts-col-md-1"}></div>
                                                </div>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field
                                                            name={'emergency_contact_info.secondary_emergency.language'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        options={languageList}
                                                                        label={'Language'}
                                                                        placeholder={'Select Language'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                        isClearable={false}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col">
                                                    </div>
                                                    <div className="ts-col-1">
                                                    </div>
                                                </div>

                                                <div className="form-header">Primary Phone</div>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field
                                                            name={'emergency_contact_info.secondary_emergency.primary_contact_info.phone_type'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        options={phoneTypeList}
                                                                        label={'Phone Type'}
                                                                        placeholder={'Select Phone Type'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                        isClearable={false}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col">
                                                        <Field
                                                            name={'emergency_contact_info.secondary_emergency.primary_contact_info.phone'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikPhoneInputComponent
                                                                        label={'Phone Number'}
                                                                        disabled={!values?.emergency_contact_info?.secondary_emergency?.primary_contact_info?.phone_type}
                                                                        placeholder={'Enter Phone Number (Primary)'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col-md-1 registration-form-icons-wrapper">
                                                        <IconButtonComponent className={"form-helper-icon"}>
                                                            <ToolTipComponent
                                                                isFormTooltip={true}
                                                                showArrow={true}
                                                                position={"left"}
                                                                tooltip={<div className={'justified-text'}>This phone number
                                                                    will be
                                                                    used to communicate with your emergency contact in case
                                                                    of an
                                                                    emergency. Please ensure that this number is valid and
                                                                    operational.</div>}>
                                                                <ImageConfig.InfoIcon/>
                                                            </ToolTipComponent>
                                                        </IconButtonComponent>
                                                    </div>
                                                </div>


                                                <FieldArray
                                                    name="emergency_contact_info.secondary_emergency.secondary_contact_info"
                                                    render={(arrayHelpers) => {
                                                        const secondaryContactInfo = values?.emergency_contact_info?.secondary_emergency?.secondary_contact_info ?? [];

                                                        return (
                                                            <>
                                                                {secondaryContactInfo.length > 0 ? (
                                                                    <>
                                                                        <div className="form-header">Alternate Phone
                                                                        </div>
                                                                        {secondaryContactInfo.map((item: any, index: any) => (
                                                                            <div className="ts-row" key={index}>
                                                                                <div className="ts-col">
                                                                                    <Field
                                                                                        name={`emergency_contact_info.secondary_emergency.secondary_contact_info[${index}].phone_type`}>
                                                                                        {(field: FieldProps) => (
                                                                                            <FormikSelectDropdownComponent
                                                                                                options={phoneTypeList}
                                                                                                label={'Phone Type'}
                                                                                                placeholder={'Select Phone Type'}
                                                                                                formikField={field}
                                                                                                fullWidth={true}
                                                                                                isClearable={false}
                                                                                            />
                                                                                        )}
                                                                                    </Field>
                                                                                </div>
                                                                                <div className="ts-col">
                                                                                    <Field
                                                                                        name={`emergency_contact_info.secondary_emergency.secondary_contact_info[${index}].phone`}>
                                                                                        {(field: FieldProps) => (
                                                                                            <FormikPhoneInputComponent
                                                                                                label={'Phone Number'}
                                                                                                disabled={!secondaryContactInfo[index]?.phone_type}
                                                                                                placeholder={'Enter Phone Number'}
                                                                                                formikField={field}
                                                                                                fullWidth={true}
                                                                                            />
                                                                                        )}
                                                                                    </Field>
                                                                                </div>
                                                                                <div
                                                                                    className="ts-col-md-1 registration-form-icons-wrapper">
                                                                                    <IconButtonComponent
                                                                                        className={"form-helper-icon"}
                                                                                        onClick={() => {
                                                                                            arrayHelpers.remove(index);
                                                                                        }}
                                                                                    >
                                                                                        <ImageConfig.DeleteIcon
                                                                                            color={"#E84142"}/>
                                                                                    </IconButtonComponent>
                                                                                    {secondaryContactInfo.length < 3 && (
                                                                                        <IconButtonComponent
                                                                                            className={"form-helper-icon"}
                                                                                            disabled={!contactInfoSchema.isValidSync(secondaryContactInfo[index])}
                                                                                            onClick={() => {
                                                                                                arrayHelpers.push({
                                                                                                    phone_type: "",
                                                                                                    phone: ""
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            <ImageConfig.AddCircleIcon/>
                                                                                        </IconButtonComponent>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                ) : (
                                                                    <ButtonComponent
                                                                        variant={"link"}
                                                                        color={"info"}
                                                                        size={"small"}
                                                                        prefixIcon={<ImageConfig.AddCircleFilled/>}
                                                                        onClick={() => {
                                                                            setFieldValue('emergency_contact_info.secondary_emergency.secondary_contact_info', [{
                                                                                phone_type: "",
                                                                                phone: ""
                                                                            }]);
                                                                        }}
                                                                    >
                                                                        Add Alternate Phone
                                                                    </ButtonComponent>
                                                                )}
                                                            </>
                                                        );
                                                    }}
                                                />

                                            </>
                                        }
                                    </>
                                    <div className="t-form-actions">
                                        <ButtonComponent
                                            id={"next_btn"}
                                            type={"submit"}
                                            size={'large'}
                                            suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                            disabled={!isValid || isSubmitting}
                                            isLoading={isSubmitting}
                                        >
                                            Next
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </Form>
                        )
                            ;
                    }}
                </Formik>
            </div>
        </div>
    )
        ;


};

export default ClientRegistrationEmergencyContactDetailsComponent;
